<template>
  <div>
    <button class="btn btn-link btn-lg text-dark" style="padding-left: 12px;"
      @click.prevent="action"
      :disabled="connected || isConnecting">
      <fa-icon v-if="demoSettings.enabled" icon="toggle-on" class="text-primary" />
      <fa-icon v-else icon="toggle-off"/>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'demo',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['demoSettings', 'connected', 'demoTimer', 'device']),
    isConnecting () {
      return this.device && this.device.isConnecting
    }
  },
  methods: {
    ...mapMutations(['toggleDemo', 'pushDemoData', 'setDemoIndexInc', 'resetDemoNextIndex', 'setDemoTimer']),
    action () {
      this.toggleDemo()

      if (this.demoSettings.enabled) {
        setTimeout(() => {
          const indexInc = this.demoSettings.maxDuration / this.demoSettings.duration
          this.setDemoIndexInc(indexInc)
          this.resetDemoNextIndex()

          const demoTimer = setInterval(() => {
            this.pushDemoData()
          }, this.demoSettings.dt * 1000)
          this.setDemoTimer(demoTimer)
        }, 500)
      } else {
        console.log('disabled')
        clearInterval(this.demoTimer)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/controls/DemoToggle.vue